import React, { PureComponent } from 'react';
import { ActualPack, VirtualPack } from '~/Api/Analytics/VirtualBrand';
import ProductPrice from '~/Api/Product/ProductPrice';
import CountryIcon from '~/UI/CountryIcon';

import styles from './styles.less';
import { Country } from '~/Api/Country';
import UnitPrice from '~/Api/Product/UnitPrice';

interface Props {
	virtualPack: VirtualPack;
	maxPricesCount: number;
}

export default class LowestPrices extends PureComponent<Props> {
	static defaultProps = {
		maxPricesCount: 3,
	};

	renderList(lowestPrice: string | undefined, type: string | undefined, country: Country, typePrefix = '') {
		return (
			<div className={styles.priceItem} key={`${lowestPrice}-${country.alpha2}`}>
				<div className={styles.country}>
					<span className={styles.countryIcon}>
						<CountryIcon code={country.alpha2} name={country.name} />
					</span>{' '}
					{country.alpha2}
				</div>
				{lowestPrice && (
					<div className={styles.price}>
						{lowestPrice} <span className={styles.priceType}>{`${typePrefix} ${type ?? ''}`}</span>
					</div>
				)}
			</div>
		);
	}

	renderLowestPriceList(lowestPrices: { actualPack: ActualPack; lowestPrice: ProductPrice | null }[]) {
		return lowestPrices.map(({ actualPack, lowestPrice }) => {
			const {
				dataSource: { country },
			} = actualPack;

			return this.renderList(lowestPrice?.price?.roundedHumanFormat(), lowestPrice?.type, country);
		});
	}

	renderLowestUnitPriceList(lowestPrices: { actualPack: ActualPack; unitPrice: UnitPrice | null }[]) {
		return lowestPrices.map(({ actualPack, unitPrice }) => {
			const {
				dataSource: { country },
			} = actualPack;

			return this.renderList(unitPrice?.roundedHumanFormatWithUnit(), unitPrice?.type, country, 'based on');
		});
	}

	render() {
		const { virtualPack, maxPricesCount } = this.props;

		const lowestPrices = virtualPack.calculateLowestPrices();
		if (lowestPrices.length === 0) {
			return null;
		}

		const lowestUnits = virtualPack.calculateLowestUnitPrices();
		return (
			<div className={styles.container}>
				<div className={styles.containerPricesHeader}>
					<div className={styles.containerLeftNoPadding}>
						<h3 className={styles.headingPackage}>
							Prices from most available package: <strong>{virtualPack.distinctName}</strong>
						</h3>
					</div>
					<div className={styles.containerRightNoPadding}>
						<h3 className={styles.headingPackage}>Prices from all packages</h3>
					</div>
				</div>
				<div className={styles.containerPrices}>
					<div className={styles.containerLeft}>
						<h2 className={styles.heading}>
							{Math.min(maxPricesCount, lowestPrices.length)}
							{' lowest prices: '}
						</h2>

						{this.renderLowestPriceList(lowestPrices.slice(0, maxPricesCount))}
					</div>
					<div className={styles.containerRight}>
						<h2 className={styles.heading}>
							{Math.min(maxPricesCount, lowestPrices.length)}
							{' lowest unit prices: '}
						</h2>

						{this.renderLowestUnitPriceList(lowestUnits.slice(0, maxPricesCount))}
					</div>
				</div>
			</div>
		);
	}
}
